export type SOSPriority = 'P0' | 'P1' | 'P2';

const P0_PATTERNS = [/accident/i, /交通事故/];
const P1_PATTERNS = [
  /breakdown/i,
  /malfunction/i,
  /故障/,
  /emergency/i,
  /紧急/,
  /injured/i,
  /受伤/,
  /passenger emergency/i,
  /乘客紧急/,
];

export function mapSOSPriority(eventType: string): SOSPriority {
  const text = eventType.trim();
  if (P0_PATTERNS.some((p) => p.test(text))) return 'P0';
  if (P1_PATTERNS.some((p) => p.test(text))) return 'P1';
  return 'P2';
}

export function sosPriorityColor(priority: SOSPriority): string {
  if (priority === 'P0') return 'red';
  if (priority === 'P1') return 'orange';
  return 'blue';
}

export function sosPriorityLabel(priority: SOSPriority): string {
  const labels: Record<SOSPriority, string> = {
    P0: 'P0 — Immediate',
    P1: 'P1 — 5 min',
    P2: 'P2 — 10 min',
  };
  return labels[priority];
}
